import React, { useCallback, useMemo, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from 'react-native'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import {
  DateWillBeFinalized,
  PaymentPlanCard,
} from '../../../../ui/atoms/PaymentPlanCard'
import { Spacer } from '../../../../ui/atoms'
import { BButton } from '../../../../ui/atoms/builder-2.0/Button'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { observer } from 'mobx-react'
import { Trans, useTranslation } from 'react-i18next'
import { frequency } from '@linqpal/models/src/dictionaries'
import { toJS } from 'mobx'
import { PricingProduct } from '@linqpal/models/src/dictionaries/pricingProduct'

interface PayWithBluetapeCreditFlow_IDLEProps {
  totalAmount: number
  paymentPlans: any[]
  onSelectPaymentPlan: (paymentPlan: any) => void
  onClose: () => void
}
export const PayWithBluetapeCreditFlow_IDLE = observer(
  ({
    totalAmount,
    paymentPlans,
    onClose,
    onSelectPaymentPlan,
  }: PayWithBluetapeCreditFlow_IDLEProps) => {
    const { t } = useTranslation('application')
    const [selectedPaymentPlan, setPaymentPlan] = useState<any>(null)

    const subtitle = useMemo(() => {
      const onePay = paymentPlans.find((p) => p.frequency === frequency.SINGLE)
      if (onePay || !paymentPlans.length) {
        return null
      } else {
        return (
          <Trans
            t={t}
            i18nKey="CreditRequestPaymentPlan.NoPaymentDueFirst30days"
            id={'credit-request-one-pay-subtitle'}
            components={{
              styled: (
                <Text
                  style={{ color: commonColors.accentText, fontWeight: '500' }}
                />
              ),
              simple: (
                <Text
                  style={{ fontWeight: '500', fontSize: 12, color: '#668598' }}
                />
              ),
            }}
          />
        )
      }
    }, [paymentPlans, t])

    const handleSelectPaymentPlan = useCallback((paymentPlan) => {
      setPaymentPlan(paymentPlan)
    }, [])

    const handleChoose = useCallback(() => {
      onSelectPaymentPlan(selectedPaymentPlan)
    }, [onSelectPaymentPlan, selectedPaymentPlan])

    return (
      <>
        <BuilderBottomModal
          visible={true}
          height={'100%'}
          onClose={onClose}
          title={t('CreditRequestPaymentPlan.mobileTitle')}
          subtitle={subtitle}
          testID={'credit-request-payment-plan-modal'}
          // eslint-disable-next-line i18next/no-literal-string
          backgroundColor="white"
          footer={
            <Footer
              onSelect={handleChoose}
              disabled={!selectedPaymentPlan}
              loading={false}
            />
          }
        >
          <>
            <View
              style={{ width: '100%' }}
              testID={'credit-request-payment-plan-content'}
            >
              {!!paymentPlans.length && <Spacer height={12} />}
              {paymentPlans.map(
                (paymentPlan, index) =>
                  paymentPlan.product === PricingProduct.LineOfCredit && (
                    <View key={index} testID={'payment-plan-card-container'}>
                      <PaymentPlanCard
                        onPress={() => {
                          handleSelectPaymentPlan(toJS(paymentPlan))
                        }}
                        paymentOption={paymentPlan}
                        selected={selectedPaymentPlan?._id === paymentPlan._id}
                        paymentAmount={totalAmount}
                        forSummaryPage={undefined}
                      />
                      <Spacer height={16} />
                    </View>
                  ),
              )}
            </View>
          </>
        </BuilderBottomModal>
      </>
    )
  },
)

interface FooterProps {
  onSelect: () => void
  disabled: boolean
  loading: boolean
}

const Footer: React.FC<FooterProps> = observer(
  ({ onSelect, disabled, loading }) => {
    const { t } = useTranslation('global')

    return (
      <>
        <Spacer height={15} />
        <DateWillBeFinalized showInfo={false} />
        <View
          style={{
            backgroundColor: '#FFF',
            width: '100%',
            alignItems: 'center',
          }}
          testID={'credit-application-continue-container'}
        >
          <Spacer height={12} />
          <View style={{ width: 335 }}>
            <BButton
              onPress={onSelect}
              buttonStyle={styles.continueButton}
              loading={loading}
              disabled={disabled}
              testID={'credit-application-continue-btn'}
            >
              {t('CreditApplication.Continue')}
            </BButton>
          </View>
          <Spacer height={45} />
        </View>
      </>
    )
  },
)

const styles = StyleSheet.create({
  heading: {
    marginTop: 40,
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 24,
    alignSelf: 'center',
    color: '#003353',
  },
  subHeading: {
    marginTop: 4,
    marginBottom: 9,
    fontWeight: '500',
    fontSize: 12,
    lineHeight: 20,
    color: '#335C75',
    width: 250,
    textAlign: 'center',
  },
  customView: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  customText: {
    marginLeft: 0,
  },
  customView2: {
    alignSelf: 'center',
  },
  loading: {
    flexDirection: 'row',
  },
  loadingText: {
    marginLeft: 20,
    fontWeight: '500',
    color: '#335C75',
  },
  loadingView: {
    minHeight: 250,
  },
  continueButton: {
    width: '100%',
    alignSelf: 'center',
  },
})
